import * as types from '../../mutation_type'
import getDate from '../../../../apis/api'

export default {
  CmpyinfoByReqdomain ({state, commit}, params) {
    return getDate.GET_CMPYINFOBYREQDOMAIN(params).then((res) => {
      commit(types.CMPYINFOBYREQDOMAIN, res)
    }).catch((thrown) => {
      console.log(thrown)
    })
  },
  // 企业的基订单和发货配置信息
  getPubordprintinfo ({state, commit}, params) {
    return getDate.GET_PUBORDPRINTINFO(params).then((res) => {
      if (res.data.status == '001') {
        state.pubordprintinfo = res.data.data
      } else {
        state.message = res.data.message
      }
    }).catch((thrown) => {
      console.log(thrown)
    })
  },
  getAddress ({state, commit}, params) {
    return getDate.GET_ADDRESS(params).then((res) => {
      if (params.selIndex == 0) {
        commit(types.GETADDRESS, res)
      } else if (params.selIndex == 1) {
        commit(types.GETADDRESSCITY, res)
      } else {
        commit(types.GETADDRESSAREA, res)
      }
    }).catch((thrown) => {
      console.log(thrown)
    })
  },
  getShoppingCart ({state, commit}, params) { // 从购物车获取商品列表
    return getDate.GET_SHOPPINGCART(params).then((res) => {
      if (params.selIndex == 0) {
        commit(types.GETADDRESS, res)
      } else if (params.selIndex == 1) {
        commit(types.GETADDRESSCITY, res)
      } else {
        commit(types.GETADDRESSAREA, res)
      }
    }).catch((thrown) => {
      console.log(thrown)
    })
  },
  removeCartItem ({state, commit}, params) { // 从购物车列表移除商品
    return getDate.GET_REMOVECARTITEM(params).then((res) => {
      if (params.selIndex == 0) {
        commit(types.GETADDRESS, res)
      } else if (params.selIndex == 1) {
        commit(types.GETADDRESSCITY, res)
      } else {
        commit(types.GETADDRESSAREA, res)
      }
    }).catch((thrown) => {
      console.log(thrown)
    })
  },
  getQuantityOfShoppingCart ({state, commit}, params) { // 从购物车获取商品总量
    return getDate.GET_QUANTITYOFSHOPPINGCART(params).then((res) => {
      if (params.selIndex == 0) {
        commit(types.GETADDRESS, res)
      } else if (params.selIndex == 1) {
        commit(types.GETADDRESSCITY, res)
      } else {
        commit(types.GETADDRESSAREA, res)
      }
    }).catch((thrown) => {
      console.log(thrown)
    })
  },
  getBrowseinfoList ({state, commit}, params) {
    return getDate.GET_BROWSEINFOLIST(params).then((res) => {
      if (res.data.status == '001') {
        // 我的足迹列表获取成功
        state.browseinfoList = res.data.data
      }
    }).catch((thrown) => {
      console.log(thrown)
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/common/actions/actions.js